import React from "react";
import PropTypes from "prop-types";
import { formatValue } from "./utils/checkoutTableUtils";

const GuestInfoSection = ({ data }) => {
  const guest = data?.customer || {};

  return (
    <>
      <div className="col-md-6">
        <table className="table table-bordered mb-3">
          <thead>
            <tr>
              <th colSpan="2" className="text-start">
                Guest Details
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <th width="35%">Booking No</th>
              <td>{data.booking_number || "-"}</td>
            </tr>

            <tr>
              <th>Guest Name</th>
              <td>{guest.name || "-"}</td>
            </tr>

            <tr>
              <th>Phone</th>
              <td>{guest.phone || "-"}</td>
            </tr>

            <tr>
              <th>Email</th>
              <td>{guest.email || "-"}</td>
            </tr>

            <tr>
              <th>Address</th>
              <td>{guest.address || "-"}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="col-md-6">
        <table className="table table-bordered mb-3">
          <thead>
            <tr>
              <th colSpan="2" className="text-start">
                Stay Information
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <th width="35%">Check In</th>
              <td>{formatValue(data.check_in_date, "date")}</td>
            </tr>

            <tr>
              <th>Check Out</th>
              <td>{formatValue(data.check_out_date, "date")}</td>
            </tr>

            <tr>
              <th>No. of Days</th>
              <td>{data.no_of_days}</td>
            </tr>

            <tr>
              <th>Status</th>
              <td>{data.booking_status}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>

  );
};

GuestInfoSection.propTypes = {
  data: PropTypes.object
};

export default GuestInfoSection;